module.exports = __webpack_public_path__ + "60059b506c650ca523d9aa5510bab249.png";